import React, { useEffect } from "react";
import { DatePicker, DatePickerInput, Button, Stack, Select, SelectItem, Tabs, Tab, TabList, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import { Calendar } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import { g90, g100 } from '@carbon/themes';
import { useDispatch, useSelector } from 'react-redux'
import LoadingContent from "../../../components/Animations/LoadingContent";
import { onGetMetricsThunk } from "./Metrics.actions";
import MetricsTable from "./MetricsTable.container";

const MetricsContainer = () => {
  const dispatch = useDispatch()
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const { error, loading, data } = useSelector(state => state.metrics)

  useEffect(() => {
    if (!loading) {
      return
    }
    dispatch(onGetMetricsThunk())
  }, [])

  return (
    <>
      <Stack gap={3}>
        <CardComponent width="100%">
          <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              HORÓMETROS Y ODÓMETROS
            </Typography>
          </Card>
          {loading && !error && (
            <LoadingContent />
          )}
          {!loading && error && (
            <>
            <CardComponent width="10%">
                <Typography className='cds--type-heading-compact-01'>
                No hay datos para este dia
                </Typography>
            </CardComponent>
            </>
          )}
          {!loading && !error && (
            <Card>
              <Card background={g100.background} width='100%' flexDirection='column' alignItems='left' gap='20px'>
                <MetricsTable />
              </Card>
            </Card>
          )}
        </CardComponent>
      </Stack>
    </>
  )
};

export default MetricsContainer;